import React, { Component } from 'react';
import { Modal } from 'antd';
import ManHourRecord from '../manHour/writeManhour'
import './style/layout.less'

class HourModal extends Component {
    state = {
        visible: false,
    }

    show = () => {
        this.setState({ visible: true });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    render() {
        const { visible } = this.state;
        return (
            <Modal
                title='工时记录'    
                visible={visible}
                onCancel={this.hide}
                bodyStyle={{ maxHeight: 500 }}
                footer={null}
                width={1300}
            >
                { visible && <ManHourRecord disableSider={true} hideHourModal={this.hide} /> }
            </Modal>
        );
    }
}

export default HourModal;



// WEBPACK FOOTER //
// ./src/components/layout/HourModal.js